// extracted by mini-css-extract-plugin
module.exports = {"details":"ArtistHistoryRow-details-3ZGxi TableRowCell-cell-2fbg4","actions":"ArtistHistoryRow-actions-e7Vwt TableRowCell-cell-2fbg4"};